module.exports = __webpack_public_path__ + "img/portrait-096.b0c31aff.jpg";